<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>how_to_reg</v-icon>
          Sign Up
        </div>
        <center>
          <span class="subheading grey--text">Generate your ID and key file</span>
        </center>
      </div>
    </v-card-title>
    <v-card-text v-if="step === 2">
      <v-alert color="error" value="true">
        <p class="subheading">
          {{ $t('dump_as_key_file.warning') }}
        </p>
        <p class="subheading">
          {{ $t('dump_as_key_file.download') }}
        </p>
      </v-alert>
      <file-creator v-if="fileStr" color="info" :href="fileStr"> <!--@click="dumpDone"--></file-creator>
      <password :open="passwordRequired" notEmpty="true" title="dump_as_key_file.password_title" @password="setPassword"></password>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs8 offset-xs2>
            <p>
              Please inform your ID to a system administrator, so you can have your access granted.
            </p>
            <p class="text-xs-center">
              <span class="title">
                Account ID: 
                <br>
                {{ this.walletAddress }}
              </span>
              <br>
              <img :src="qr" style="width: 100px; height: auto;"/>
            </p>
          </v-flex>
        </v-layout>
    </v-container>
    </v-card-text>
    <v-card-actions>
      <v-flex align-center text-xs-center>
        <v-btn color="error" dark @click="createWallet" v-if="step === 1">
          <v-icon>person_add</v-icon>
        </v-btn>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import password from 'components/PasswordCreate'
import webWallet from 'libs/web-wallet'
import fileCreator from 'components/FileCreator'
import keyfile from 'libs/keyfile'
import qrcode from 'qrcode'

export default {
  data() {
    return {
      step: 1,
      passwordRequired: false,
      fileStr: false,
      walletAddress: '',
      qr: ''
    }
  },
  props: ['view'],
  watch: {
    view: function() {
      this.step = 1
    }
  },
  components: {
    password,
    fileCreator,
  },
  methods: {
    setPassword(password) {
      const wallet = webWallet.restoreFromMnemonic(webWallet.generateMnemonic(), Date.now())
      this.fileStr = 'data:text/plain,'+keyfile.build(keyfile.encode(wallet.getPrivKey(), password))
      this.walletAddress = wallet.getAddress()
      this.drawQrCode()
      this.passwordRequired = false
    },
    createWallet() {
      this.step = 2
      this.passwordRequired = true
    },
    dumpDone() {
      setTimeout(() => {
        this.$emit('created')
      }, 1000)
    },
    drawQrCode() {
      qrcode.toDataURL(this.walletAddress, (err, url) => {
        this.qr = url
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Create.vue